module.exports = __webpack_public_path__ + "src/assets/img/nordic.e08cab11.png";